import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  setFinanceCompanyLoadingTable,
  setFMEIdPair,
  setSelectedDateFilterPair,
  setSelectedFinanceCompanyFilter,
  setSelectedLinkedFilterPair,
  setSelectedStatusFilterPair,
} from "../../../../../../../features/financeReceiptSlice";
import { Box } from "@mui/system";
import FilterComponent from "../../../../../../ReusableFIlterComponent/FilterComponent";
import { selectUserToken } from "../../../../../../../features/userSlice";
import { ReceiptsEndPointLogic } from "../../../../../../../logic/Finance/ProviderExpense/ReceiptsEndpointLogic";
import { useSearchParams } from "react-router-dom";

const PairAddRecordsFilterObjs = () => {
  const dispatch = useDispatch();
  const [searchStatus, setSearchStatus] = useState("");
  const [searchLinked, setSearchLinked] = useState("");
  const [searchFinanceCompany, setSearchFinanceCompany] = useState("");
  const {
    selectedStatusFilterPair,
    selectedLinkedFilterPair,
    selectedDateFilterPair,
    selectedFinanceCompanyFilter,
    normalizedFinancialMonthlyEarningsData,
    allCompanies,
  } = useSelector((state: any) => state.receipts);
  const [searchParams] = useSearchParams();
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const financeCompanyOptions = (allCompanies || [])
    .filter(
      (c: any) =>
        c?.shared_uid != null &&
        c?.finance_company_name != null &&
        String(c.shared_uid).trim() !== "" &&
        String(c.finance_company_name).trim() !== "",
    )
    .map((c: any) => ({
      value: String(c.shared_uid),
      label: String(c.finance_company_name),
    }));
  const handleFinanceCompanyApply = async (selection: string[]) => {
    if (!selection?.length) return;
    const shared_uid = selection[0];
    try {
      dispatch(setFinanceCompanyLoadingTable(true));
      await ReceiptsEndPointLogic.getFinancialMonthlyEarnings(
        oauthTokenHeader,
        shared_uid,
      );
    } catch (error) {
      console.error("Failed to fetch FME records", error);
    } finally {
      dispatch(setFinanceCompanyLoadingTable(false));
    }
  };
  const filterConfig = [
    {
      key: "date",
      label: "Date",
      selectedOption: selectedDateFilterPair,
      filterName: "month",
      data: normalizedFinancialMonthlyEarningsData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedDateFilterPair(updatedSelection)),
      count: 0,
      colorSelected:
        selectedDateFilterPair !== null && selectedDateFilterPair.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      isDateRangeFilter: true,
    },
    {
      key: "Status",
      label: "Select one Status or more",
      searchTerm: searchStatus,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchStatus(e.target.value),
      selectedOption: selectedStatusFilterPair,
      filterName: "fme_status",
      data: normalizedFinancialMonthlyEarningsData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedStatusFilterPair(updatedSelection)),
      count: selectedStatusFilterPair && selectedStatusFilterPair.length,
      colorSelected:
        selectedStatusFilterPair !== null && selectedStatusFilterPair.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: true,
      showSearch: true,
    },
    {
      key: "Receipts Linked",
      label: "Select one Linked or more",
      searchTerm: searchLinked,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchLinked(e.target.value),
      selectedOption: selectedLinkedFilterPair,
      filterName: "linked",
      data: normalizedFinancialMonthlyEarningsData,
      onSelectionChange: (updatedSelection: any) =>
        dispatch(setSelectedLinkedFilterPair(updatedSelection)),
      count: selectedLinkedFilterPair && selectedLinkedFilterPair.length,
      colorSelected:
        selectedLinkedFilterPair !== null && selectedLinkedFilterPair.length > 0
          ? "#9C27B0"
          : "#000000DE",
      multiSelect: false,
      showSearch: false,
    },
    {
      key: "financeCompany",
      name: "Finance Company",
      label: "Select Finance Company",
      searchTerm: searchFinanceCompany,
      onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) =>
        setSearchFinanceCompany(e.target.value),
      selectedOption: selectedFinanceCompanyFilter,
      filterName: "label",
      options: financeCompanyOptions,
      onSelectionChange: (updated: any) =>
        dispatch(setSelectedFinanceCompanyFilter(updated)),
      onSelectionApplied: handleFinanceCompanyApply,
      count: selectedFinanceCompanyFilter?.length || 0,
      colorSelected: selectedFinanceCompanyFilter?.length
        ? "#9C27B0"
        : "#000000DE",
      multiSelect: false,
      showSearch: true,
    },
  ];

  const handleFinanceCompanyApplyWhileClearing = async () => {
    const shared_uid = searchParams.get("company_shared_uid") || "";
    try {
      dispatch(setFinanceCompanyLoadingTable(true));
      await ReceiptsEndPointLogic.getFinancialMonthlyEarnings(
        oauthTokenHeader,
        shared_uid,
      );
    } catch (error) {
      console.error("Failed to fetch FME records", error);
    } finally {
      dispatch(setFinanceCompanyLoadingTable(false));
    }
  };

  const clearFilters = () => {
    if (selectedFinanceCompanyFilter?.length > 0) {
      handleFinanceCompanyApplyWhileClearing();
    }
    dispatch(setSelectedStatusFilterPair(null));
    setSearchStatus("");
    dispatch(setSelectedLinkedFilterPair(null));
    setSearchLinked("");
    dispatch(setSelectedDateFilterPair(null));
    dispatch(setFMEIdPair(null));
    dispatch(setSelectedFinanceCompanyFilter(null));
  };
  return (
    <Box>
      <FilterComponent
        filterConfig={filterConfig}
        clearFilters={clearFilters}
      />
    </Box>
  );
};

export default PairAddRecordsFilterObjs;
